export interface UserProfile {
  id: number
  name: string
  email: string | null
  company_name?: string | null
  avatar_url?: string | null
  role?: string
}

export interface LoginSession {
  session_id: string
  session_class: 'runtime' | 'account_management'
  device_fingerprint: string | null
  issued_at: string
  last_seen_at: string
  expires_at: string
  revoked_at: string | null
  revoke_reason: string | null
  current: boolean
}

export interface Overview {
  user: UserProfile
  sessions: LoginSession[] | null
  account: Record<string, unknown> | null
  subscription: Record<string, unknown> | null
  quota: Record<string, unknown> | null
  transactions: { items?: Array<Record<string, unknown>> } | null
  plans: Array<Record<string, unknown>> | null
}

export class ApiError extends Error {
  constructor(readonly status: number, message: string, readonly errorCode?: string) { super(message) }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { accept: 'application/json', ...(init?.body ? { 'content-type': 'application/json' } : {}), ...init?.headers },
  })
  const value = await response.json().catch(() => ({})) as T & { error?: string; errorCode?: string }
  if (!response.ok) throw new ApiError(response.status, value.error ?? `HTTP ${response.status}`, value.errorCode)
  return value
}

export const loadOverview = () => api<Overview>('/api/account/overview')

export function fmtDate(value: unknown): string {
  if (typeof value !== 'string' || !value) return '—'
  return new Intl.DateTimeFormat('zh-CN', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value))
}

export function text(value: unknown, fallback = '—'): string {
  return typeof value === 'string' || typeof value === 'number' ? String(value) : fallback
}
